import React from 'react'
import { withRouter } from 'react-router-dom'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Layout, Container, Content, PageTitle } from 'src/components/Layout'
import { FooterActionsParent } from 'src/components/Layout/Footer/FooterActions'
import { Flex, Box } from '@chakra-ui/react'
import { Checkbox } from 'src/components/Form'
import Loader from 'src/components/Loader/Loader'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from 'src/modules/Documents/translations'
import EventsService from 'src/utils/events-service'
import Button from 'src/components/Button/Button'
import withToast from 'src/components/Toast'
import { isEmpty } from 'src/utils/helpers'
import { isColorWhite } from 'src/utils/colors'
// import { getAddToWalletUrl } from 'src/modules/Documents/helper'
import styles from './styles.module.less'

class Consent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isChecked: props.hasSlipConsent,
    }
  }

  componentDidUpdate(prevProps) {
    const { intl, saveSlipConsentResponse, setSlipConsent, toast } = this.props

    // If there is save response and it changed (it's empty object while submitting)
    if (
      !isEmpty(saveSlipConsentResponse) &&
      saveSlipConsentResponse !== prevProps.saveSlipConsentResponse
    ) {
      if (saveSlipConsentResponse.success) {
        // Now that it's saved in backend (database), save it in our redux state as well
        setSlipConsent(true)

        // Continue opening selected document (knowing which document is already in redux state)
        this.afterConsent()
      } else {
        toast({
          title: intl.formatMessage(intlMessagesApp.appErrorTitle),
          description:
            saveSlipConsentResponse.message ||
            intl.formatMessage(intlMessagesApp.appErrorDescription),
          status: 'error',
        })
      }
    }
  }

  afterConsent = () => {
    // TODO: PAT-2042 Use this if we need to show "Add to wallet" button in summary before consent is submitted
    // const { match, history, setAddedToWallet, document } = this.props

    // If we landed to consent page by clicking "add to wallet" button
    // if (match.params && match.params.hasOwnProperty('referer') && match.params.referer === 'wallet') {
    //   const walletUrl = getAddToWalletUrl(document)
    //   if(walletUrl) {
    //
    //     // Mark this pink slip as added, so that we can hide button from summary view
    //     if(typeof setAddedToWallet === 'function') {
    //       setAddedToWallet(document.id)
    //     }
    //
    //     window.open(walletUrl, '_blank')
    //
    //     history.push('/documents')
    //
    //     return true
    //   }
    // }

    // If we landed to consent page by opening a Pink Slip
    this.props.history.push('/documents/item')
  }

  onSubmit = async e => {
    e.preventDefault()

    const { savePinkSlipConsent, isWidgetState } = this.props
    const { isChecked } = this.state

    // Exit if not checked
    if (!isChecked) {
      return false
    }

    const visitorData = await EventsService.getVisitorData({ isWidget: isWidgetState })

    // Save consent in backend (database)
    savePinkSlipConsent(true, visitorData)
  }

  onCancel = e => {
    e.preventDefault()

    this.props.history.push('/documents')
  }

  onConsentChange = e => {
    this.setState({
      isChecked: !!e.target.checked,
    })
  }

  render() {
    const { intl, features, isSaveSlipConsentInProgress, pageBackground } = this.props
    const { isChecked } = this.state

    const foundedFeature = features.find(f => f.id == 'documents')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.documentsHeadline)

    let { countryIsoCode } = this.props
    return (
      <Layout>
        <Content>
          <PageTitle subtitle={title} title={intl.formatMessage(intlMessages.documentHeadline)} />
          <Container padder>
            {isSaveSlipConsentInProgress ? (
              <Loader styleVariation='staticWithHeight' />
            ) : (
              <FooterActionsParent className={styles.contentHolder}>
                <form onSubmit={this.onSubmit}>
                  <h3 className={styles.title}>
                    {intl.formatMessage(intlMessages.documentConsentTitle)}
                  </h3>
                  <ol className={styles.list}>
                    <li className={styles.listItem}>
                      <FormattedMessage
                        id='app.document.consent.text1'
                        defaultMessage='The law obligates insureds to produce a pink slip in certain circumstances. It is the insured’s responsibility to ensure that they are able to produce it. Failure to produce a pink slip for reasonable inspection by a police officer may result in charges being brought against the policyholder. The absence of internet services, drained battery or charge on an electronic mobile device, or limited or obstructed visibility of the electronic insurance card - e.g. due to a damaged screen - may limit the availability and accessibility of E-Slip on demand. It is therefore recommended that insurers continue to carry their paper-based pink slips.'
                      />
                    </li>
                    <li className={styles.listItem}>
                      {countryIsoCode && countryIsoCode.toLowerCase() === 'us' ? (
                        <FormattedMessage
                          id='app.document.consent.text2us'
                          defaultMessage='The use of E-Slips has only been approved in {region} to date. Clients travelling outside these provinces will be required to produce a paper-based pink slip, which may require direct confirmation with their insurer or agent.'
                          values={{
                            region: (
                              <b>
                                Alberta, Newfoundland and Labrador, Nova Scotia, Ontario, Quebec,
                                Northwest Territories and Yukon
                              </b>
                            ),
                          }}
                        />
                      ) : (
                        <FormattedMessage
                          id='app.document.consent.text2'
                          defaultMessage='The use of E-Slips has only been approved in {region} to date. Clients travelling outside these provinces will be required to produce a paper-based pink slip, which may require direct confirmation with their insurer or broker.'
                          values={{
                            region: (
                              <b>
                                Alberta, Newfoundland and Labrador, Nova Scotia, Ontario, Quebec,
                                Northwest Territories and Yukon
                              </b>
                            ),
                          }}
                        />
                      )}
                    </li>
                    <li className={styles.listItem}>
                      <FormattedMessage
                        id='app.document.consent.text3'
                        defaultMessage='The client is responsible for any loss or damage to their phones that may occur while their phones are in the care, custody or control of a third party who has authority to request access.'
                      />
                    </li>
                    <li className={styles.listItem}>
                      <FormattedMessage
                        id='app.document.consent.text4'
                        defaultMessage='By electronically sharing an E-Slip with others, including law enforcement, clients are providing those parties with their personal information, including their email address.'
                      />
                    </li>
                  </ol>
                  <div className={styles.checkboxHolder}>
                    <Checkbox
                      name='pink-slip-consent'
                      onChange={this.onConsentChange}
                      label={intl.formatMessage(intlMessagesApp.appGlobalIAgree)}
                      isChecked={isChecked}
                      {...this.props}
                    ></Checkbox>
                  </div>

                  <Flex justify={'center'}>
                    <Button
                      variant={isColorWhite(pageBackground) ? 'outlineContrast' : 'outline'}
                      onClick={this.onCancel}
                    >
                      {intl.formatMessage(intlMessagesApp.appGlobalCancel)}
                    </Button>
                    <Box ml={'20px'}>
                      <Button type='submit' disabled={!isChecked}>
                        {intl.formatMessage(intlMessagesApp.appGlobalAccept)}
                      </Button>
                    </Box>
                  </Flex>
                </form>
              </FooterActionsParent>
            )}
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(withToast(Consent)))
